(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template--product-no-qty-selector"]) return;
  try {
    
  $(window).on('load', function(){
    $(`<div class='review-desc'><h4 class='review-desc-heading'>Before You Write a Review…</h4>
      We love hearing your feedback on our products, but current regulations don’t allow us to post product reviews that make any claims about CBD and specific health conditions. Here are some guidelines to follow to ensure we can post your review:
INCLUDE your impressions and opinions about our products, if they worked for you and how they’ve impacted your self-care routine.
AVOID mentioning any specific health or skin conditions as well as any health-related outcomes you may have experienced.
We hope someday soon we’ll be able to speak more openly about River Organics' CBD products, but for now thanks for helping us follow the rules.</div>`).insertAfter($('#judgeme_product_reviews .jdgm-rev-widg__title'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template--product"]) return;
  try {
    
  $(window).on('load', function(){
    $(`<div class='review-desc'><h4 class='review-desc-heading'>Before You Write a Review…</h4>
      We love hearing your feedback on our products, but current regulations don’t allow us to post product reviews that make any claims about CBD and specific health conditions. Here are some guidelines to follow to ensure we can post your review:
INCLUDE your impressions and opinions about our products, if they worked for you and how they’ve impacted your self-care routine.
AVOID mentioning any specific health or skin conditions as well as any health-related outcomes you may have experienced.
We hope someday soon we’ll be able to speak more openly about River Organics' CBD products, but for now thanks for helping us follow the rules.</div>`).insertAfter($('#judgeme_product_reviews .jdgm-rev-widg__title'));
  });

  } catch(e) { console.error(e); }
})();
})();
